import type { ReactNode } from "react";
import type { BadgeTone } from "../../types/vtc";
import { cn } from "../../lib/format";

interface BadgeProps {
  tone?: BadgeTone;
  className?: string;
  children: ReactNode;
}

const TONES: Record<BadgeTone, string> = {
  neutral: "bg-surface text-ink-soft",
  blue: "bg-tone-blue-bg text-tone-blue-fg",
  green: "bg-tone-green-bg text-tone-green-fg",
  amber: "bg-tone-amber-bg text-tone-amber-fg",
  red: "bg-tone-red-bg text-tone-red-fg",
};

export default function Badge({
  tone = "neutral",
  className,
  children,
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded px-2 py-1 text-xs font-medium",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
